import React from "react";

import DatePicker from "react-datepicker";

export default function DateInput({
  startDate,
  disabled,
  placeholder,
  onChange,
  label,
  error,
  value,
  errorText,
  icon,
  readOnly,
  minDate,
  className,
  maxDate,
}) {
  return (
    <div className="input__outer">
      {label && <label className="!mb-1">{label}</label>}
      <div
        className={
          "input " +
          (error && value === "" ? "error " : "") +
          (icon ? "wIcon" : "")
        }
      >
        <DatePicker
          disabled={disabled}
          onChange={onChange}
          startDate={disabled ? "" : startDate}
          placeholderText={placeholder}
          selected={startDate}
          readOnly={readOnly}
          minDate={minDate}
          maxDate={maxDate}
          className={`!rounded-lg !border !border-gray-200 ${className}`}
        />
        {icon && (
          <div
            className={`input__icon simple flex items-center mt-2 mr-2 justify-center`}
          >
            {icon}
          </div>
        )}
      </div>
      {error && value === "" && <div className="input__error">{errorText}</div>}
    </div>
  );
}
